import { productFamilyCodes } from './productFamilyCodes';
import { discountCardCodes } from './discountCardCodes';

const discountCardsMap = {
  [productFamilyCodes.INTER_RAIL]: {
    code: discountCardCodes.INTER,
    name: 'INTERRAIL'
  },
  [productFamilyCodes.FIP_E]: {
    code: discountCardCodes.FIP,
    name: 'FIP CARD HOLDER'
  },
  [productFamilyCodes.FIP_I]: {
    code: discountCardCodes.FIP,
    name: 'FIP CARD HOLDER'
  },
  [productFamilyCodes.SNCX]: {
    code: discountCardCodes.SNCX,
    name: 'SNCX DISCOUNT CARD'
  },
  [productFamilyCodes.DUTY_TOLLABLE]: {
    code: discountCardCodes.DUTYSNCF,
    name: 'SNCF FIP SERVICE'
  },
  [productFamilyCodes.VIP_RP]: {
    code: discountCardCodes.VIP_RP,
    name: 'VIP RP'
  },
  [productFamilyCodes.INVITATION]: {
    code: discountCardCodes.INVIT,
    name: 'INVITATION'
  },
  [productFamilyCodes.DUTY_NON_TOLLABLE]: {
    code: discountCardCodes.DUTYSNCF,
    name: 'FIP SERVICE'
  }
};

export default discountCardsMap;
